<template>
  <generic-list :apiUrls="apiUrls" :formCols="formCols" :updateCols="updateCols" :tableCols="tableCols"></generic-list>
</template>

<script>
import genericList from '@/views/commonPage/genericList.vue'
import URL from '@/views/business/util/url'
let isDelete = { "1": "启用", "2": "禁用" };
export default {
  name: "pushMsgConfig",
  components: {
    genericList
  },
  data() {
    return {
      apiUrls: {
        query: URL.pushMsgConfig.query,
        addOrUpdate: URL.pushMsgConfig.addOrUpdate,
        deleteBatchIds: URL.pushMsgConfig.deleteBatchIds
      },
      formCols: [
        { title: '应用名称', field: 'appName' },
        { click: window.$t('business.bt.search') },
        { click: window.$t('business.bt.add') }
      ],
      updateCols: [
        { title: 'id', field: 'id', hidden: true },
        { title: 'appKey', field: 'appKey', required: true },
        { title: 'appSecret', field: 'appSecret', required: true },
        { title: '应用名称', field: 'appName', required: true },
        { title: '渠道', field: 'channel' },
        { title: '备注', field: 'remark' },
        { title: '状态', field: 'isDelete', type: 2, optionList: isDelete, isNumber: true, required: true },
      ],
      tableCols: [
        { title: 'appKey', field: 'appKey' },
        { title: 'appSecret', field: 'appSecret' },
        { title: '应用名称', field: 'appName' },
        { title: '渠道', field: 'channel' },
        { title: '备注', field: 'remark' },
        { title: '创建时间', field: 'createDate' },
        { title: '创建人', field: 'createUser' },
        { title: '修改人', field: 'updateUser' },
        { title: '修改时间', field: 'updateDate' },
        {
          title: '状态', field: 'isDelete', render: (data, full) => {
            return isDelete[data];
          }
        },
        {
          title: window.$t("business.bt.operation"), minWidth: "180", btnClick: [
            { name: window.$t("business.bt.edit"), click: "update", type: "primary", size: "mini", icon: "el-icon-edit" },
            { name: window.$t("business.bt.delete"), click: "delete", type: "primary", size: "mini", icon: "el-icon-delete" }
          ]
        },
      ]
    };
  }
}
</script>